import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit';
import { sendGetRequest, sendPostRequest } from '../services/PDService';
import { LocalStorageGet } from '../utility/LocalStorageUtil';
import { addResult, sendBranchingOption, sendChat } from './chat/ChatThunks';
import {
  objectiveGroupsWithHintsSelector,
  objectivesSelector,
} from './PatientSlice';

// note we're currently using the objectives data from the patient slice
// because it doesn't benefit much to be flat when we're not updating the data
// export const getObjectives = createAsyncThunk(
//   'objectives/getObjectives',
//   async (vhId, { getState, dispatch }) => {
//     const response = await sendGetRequest('objectives?vhId=' + vhId);
//     return response.data;
//   }
// );

// export const getObjectiveGroups = createAsyncThunk(
//   'objectives/getObjectiveGroups',
//   async (vhId, { getState, dispatch }) => {
//     const response = await sendGetRequest('objective-groups?vhId=' + vhId);
//     return response.data;
//   }
// );

export const markShownObjectiveHint = createAsyncThunk(
  'objectives/showObjectiveHint',
  async (objectiveId, { getState, dispatch }) => {
    const chatSessionId = getState().chat.chatSessionId;
    const objective = objectivesSelector(getState()).find(
      (obj) => obj.id === objectiveId
    );
    if (!objective) {
      return Promise.reject('No objective found with id ' + objectiveId);
    }
    const formData = {
      objectiveId,
      userId: getState().user.ID,
      username: getState().user.Name,
      userText: objective?.hint ?? '',
      type: 'hint',
      platform: 'web',
      chatSessionId: chatSessionId,
      organisationID: LocalStorageGet('currentOrganisationID', '-1'),
    };
    const response = await sendPostRequest(
      'assessments/log',
      formData,
      chatSessionId,
      false,
      getState().virtualHuman.data.ShareToken
    );
    return response.data;
  }
);

const ObjectivesSlice = createSlice({
  name: 'objectives',
  initialState: {
    // objectiveGroups: {},
    // objectives: {},
    shownHintObjectiveIds: [],
    currentHint: null,
    hitObjectiveIds: [],
    groupIdHintIndicatorShown: null,
    hintScoreWarningShown: false,
    // need to track this so we know which is the first group with a hint we need to show a hint indicator for
    objectiveGroupsComplete: [],
  },
  reducers: {
    // format: { objectiveId: 1, text: 'hint text' }
    unsetCurrentHint: (state) => {
      state.currentHint = null;
    },
    setCurrentHint: (state, action) => {
      if (!state.shownHintObjectiveIds.includes(action.payload.objectiveId)) {
        state.shownHintObjectiveIds.push(action.payload.objectiveId);
      }
      state.currentHint = action.payload;
    },
    setGroupIdHintIndicatorShown: (state, action) => {
      state.groupIdHintIndicatorShown = action.payload;
    },
    setHintScoreWarningShown: (state) => {
      state.hintScoreWarningShown = true;
    },
    setObjectiveGroupComplete: (state, action) => {
      state.objectiveGroupsComplete.push(action.payload);
    },
  },
  extraReducers: {
    [sendChat.fulfilled]: (state, action) => {
      if (action.payload?.objectiveId) {
        state.hitObjectiveIds.push(action.payload.objectiveId);
      }
    },
    [sendBranchingOption.fulfilled]: (state, action) => {
      if (action.payload.data?.data?.objectiveIdHit) {
        state.hitObjectiveIds.push(action.payload.data?.data?.objectiveIdHit);
      }
    },
    [addResult.fulfilled]: (state, action) => {
      if (action.payload.objectiveId) {
        state.hitObjectiveIds.push(action.payload.objectiveId);
      }
    },
    // [getObjectives.fulfilled]: (state, action) => {
    //   state.objectives = action.payload;
    // },
    // [getObjectiveGroups.fulfilled]: (state, action) => {
    //   state.objectiveGroups = action.payload;
    // },
  },
});

export const {
  unsetCurrentHint,
  setCurrentHint,
  setObjectiveGroupComplete,
  setGroupIdHintIndicatorShown,
  setHintScoreWarningShown,
} = ObjectivesSlice.actions;

// export const objectivesSelector = (state) => state.objectives;
// export const objectiveGroupsSelector = (state) => state.objectiveGroups;
export const shownHintObjectiveIdsSelector = (state) =>
  state.objectives.shownHintObjectiveIds;
export const currentHintSelector = (state) => state.objectives.currentHint;
export const hitObjectiveIdsSelector = (state) =>
  state.objectives.hitObjectiveIds;
export const groupIdHintIndicatorShownSelector = (state) =>
  state.objectives.groupIdHintIndicatorShown;
export const hintScoreWarningShownSelector = (state) =>
  state.objectives.hintScoreWarningShown;
export const objectiveGroupsCompleteSelector = (state) =>
  state.objectives.objectiveGroupsComplete;

export const firstIncompleteObjectiveGroupWithUnusedHintSelector =
  createSelector(
    objectiveGroupsWithHintsSelector,
    shownHintObjectiveIdsSelector,
    objectiveGroupsCompleteSelector,
    (
      objectiveGroupsWithHints,
      shownHintObjectiveIds,
      objectiveGroupsComplete
    ) => {
      return objectiveGroupsWithHints.find((objectiveGroup) => {
        return (
          !objectiveGroupsComplete.includes(objectiveGroup.id) &&
          objectiveGroup.objectives.some((objective) => {
            return !shownHintObjectiveIds.includes(objective.id);
          })
        );
      });
    }
  );

export default ObjectivesSlice;
